export function returnCitySN() {
  let returnCityip = ''
    return returnCityip
  }
